import { Heading, Paragraph } from "@/components/ui/Typography";

import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";

const Hero = ({data}:{data: MicroSite}) => { 

  if(!data) {
    return null;
  };

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full justify-center overflow-hidden min-h-96 xl:min-h-[35rem]">
           {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-10"></div>
      {/* Bg Image */}
        <img src={data?.headerSection?.headerImageUrl ?? "/blank-image-placeholder.png"} alt={"Hero Section"} className="w-full object-cover h-full object-center absolute inset-0 " />

        {/* Title and description */}
        <div className="absolute z-20 flex flex-col gap-2 w-full px-4 lg:px-16">
          <img src={data?.branding?.websiteLogoUrl} alt="" className="h-12 object-contain w-fit min-w-fit mb-16" />
          <div className="flex items-center gap-3">
          <Heading level={1} className="" style={{color: data?.branding?.textColorCode}}>{data?.headerSection?.headerTitle}</Heading>
          </div>
          <Paragraph  className=" lg:w-1/3" style={{color: data?.branding?.textColorCode}} dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.headerSection?.headerDescription ?? "") }} ></Paragraph>
        </div>
      </div>
    )
  };


  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default Hero